// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"button_g2MO4"};